import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import type { Report } from '@repo/shared/schema';
import type { ReactNode } from 'react';
import { RiskBadge } from './shared';
export const Profile = ({
  report,
  metadata,
  embedded = false,
}: {
  report: Report;
  metadata?: ReactNode;
  embedded?: boolean;
}) => {
  useLocale();

  const company = report.reportType === 'KYB';
  const data = company ? report.companyInformation : report.clientInformation;
  const fields = company
    ? [
        ['companyRegistrationNumber', t('extra.registrationNumber')],
        ['countryOfIncorporation', t('auth.country')],
        ['incorporationDate', t('extra.incorporationDate')],
        ['industry', t('reports.industry')],
        ['registeredAddress', t('extra.registeredAddress')],
        ['contactEmail', t('reports.email')],
        ['contactPhone', t('reports.phone')],
      ]
    : [
        ['nationality', t('reports.nationality')],
        ['idNumber', t('reports.nationalId')],
        ['dateOfBirth', t('reports.dateOfBirth')],
        ['employmentStatus', t('extra.occupation')],
        ['netWorth', t('extra.netWorth')],
        ['email', t('reports.email')],
        ['phone', t('reports.phone')],
      ];
  return (
    <div className={embedded ? 'raven-profile' : 'raven-panel raven-profile'}>
      <div className="flex items-start gap-4">
        <span className="flex size-14 shrink-0 items-center justify-center rounded-full bg-[#eeebf4] text-sm">
          {report.reportName?.slice(0, 2).toUpperCase()}
        </span>
        <div className="min-w-0 flex-1">
          <h2 className="break-words">{report.reportName}</h2>
          <div className="mt-3 flex justify-between gap-2 text-xs">
            <span>{t('workspace.riskLevel')}</span>
            <RiskBadge level={report.riskLevel} />
          </div>
        </div>
      </div>
      {metadata}
      <h3 className="mt-5">
        {company ? t('reports.companyInformation') : t('reports.clientInformation')}
      </h3>
      <dl>
        {fields.map(([key, label]) => (
          <div className="contents" key={key}>
            <dt>{label}</dt>
            <dd>
              {String(
                (data as Record<string, unknown> | undefined)?.[key!] ?? t('extra.notProvided'),
              )}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
